import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TasacionArchivo } from '../models/TasacionArchivo';
import { SalesPerson } from '../models/SalesPerson';
import { ApiResult } from '../models/ApiResult';
import { TasacionesComponent } from '../components/tasaciones/tasaciones.component';
import { TasacionModel } from '../models/TasacionModel';
import { LookupData } from '../models/lookup';




@Injectable()
export class TasacionesService {

  myAppUrl: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }
  getTasaciones() {
    return this.http.get(`${this.myAppUrl}api/Tasaciones/`);
  }

  getTasacionesByEstados(idEstadoFrom: number, idEstadoTo: number, isChecked: boolean) {
    return this.http.get(`${this.myAppUrl}api/Tasaciones/?idEstadoFrom=${idEstadoFrom.toString()}&idEstadoTo=${idEstadoTo.toString()}&isChecked=${isChecked}`);
  }

  getTasacionesByEstado(idEstado: number, isChecked: boolean) {
    return this.http.get(this.myAppUrl + 'api/Tasaciones/?idEstado=' + idEstado.toString()+'&isChecked=' + isChecked);
  }

  getTasacionesCheckedYear(isChecked: boolean) {
    console.log(this.myAppUrl + 'api/Tasaciones/?isChecked=' + isChecked);
    return this.http.get(this.myAppUrl + 'api/Tasaciones/?isChecked=' + isChecked);
  }

  getTasacionesByIdPs(idPS: number) {
    return this.http.get(`api/Tasaciones/PS/${idPS}`);
  }

  getTasacionID(ID) : Observable<TasacionModel> {
    return this.http.get<TasacionModel>(this.myAppUrl + 'api/Tasaciones/' + ID);
  }

  postTasacion(tasacion) {
    return this.http.post(this.myAppUrl + 'api/Tasaciones/', tasacion);
  }

  updateTasacion(id, tasacion) {
    return this.http.put(this.myAppUrl + 'api/Tasaciones/' + id, tasacion);
  }

  removeTasacion(id) {
    return this.http.delete(this.myAppUrl + 'api/Tasaciones/' + id);
  }

  getTipoInmuebles() {
    return this.http.get(this.myAppUrl + 'api/Tipoinmueble/');
  }

  getClientes() {
    return this.http.get(this.myAppUrl + 'api/Clientes/');
  }

  getUsers() {
    return this.http.get(this.myAppUrl + 'api/Users/');
  }

  getEstadoTasaciones() {
    return this.http.get(this.myAppUrl + 'api/EstadoTasacion');
  }

  getEntidadesFinancieras() {
    return this.http.get(this.myAppUrl + 'api/EntidadFinanciera');
  }

  getFinalidad() {
    return this.http.get(this.myAppUrl + 'api/Finalidad');
  }

  getArchivosTasacion(TasacionID): Observable<TasacionArchivo[]> {
    return this.http.get<TasacionArchivo[]>(this.myAppUrl + 'api/Tasaciones/Ficheros/GetFicherosList?TasacionID=' + TasacionID);
  }

  getArchivosTasacionNoVisita(TasacionID): Observable<TasacionArchivo[]> {
    return this.http.get<TasacionArchivo[]>(this.myAppUrl + 'api/Tasaciones/Ficheros/GetFicherosList?TasacionID=' + TasacionID + '&noVisita=true');
  }

  getTecnico() {
    return this.http.get(this.myAppUrl + 'api/Users/tecnico');
  }

  getValidador() {
    return this.http.get(this.myAppUrl + 'api/Users/validador');
  }

  getContratos() {
    return this.http.get(this.myAppUrl + 'api/Contratos');
  }

  removeArchivoTasacion(TasacionArchivoID) {
    const url = this.myAppUrl + 'api/Tasaciones/fileDelete?TasacionArchivoID=' + TasacionArchivoID;
    return this.http.get(url);
  }

  duplicarTasacion(id, copias): Observable<ApiResult> {
    return this.http.post<ApiResult>(`${this.myAppUrl}api/Tasaciones/duplicar/${id}?copias=${copias}`, null);
  }

  getIncidencias(id: number) {
    return this.http.get(this.myAppUrl + 'api/incidencia/tasacion/' + id);
  }

  getEstadoTasacion(id: number) {
    return this.http.get(this.myAppUrl + 'api/tasaciones/estado/' + id);
  }

  getSalesPerson(idOficinaFact?: string): Observable<SalesPerson> {
    if (idOficinaFact) {
      return this.http.get<SalesPerson>(this.myAppUrl + 'api/SalesPerson?oficinaFactId=' + idOficinaFact);
    }
    else
      return this.http.get<SalesPerson>(this.myAppUrl + 'api/SalesPerson');
  }

  getTasacionesFiltered(searchTerm: string) {
    return this.http.get(this.myAppUrl + 'api/Tasaciones/FastSearch?k=' + searchTerm);
  }

  getOficinasFacturacion() {
    return this.http.get(this.myAppUrl + 'api/oficinaFacturacion/getDropDownList');
  }

  getCanalesEntrada() {
    return this.http.get(this.myAppUrl + 'api/canalEntrada/getDropDownList');
  }

  getPrescriptores() {
    return this.http.get(this.myAppUrl + 'api/prescriptor/getDropDownList')
  }

  reopenVisit(idTasacion: number) {
    return this.http.post(`${this.myAppUrl}api/Tasaciones/reopenVisit/${idTasacion}`, null);
  }

  getTecnicosData(tasacionID: number) {
    return this.http.get(`${this.myAppUrl}api/Tasaciones/GetRTecnicos/${tasacionID}`);
  }

  getPsStatsData() {
    return this.http.get(`${this.myAppUrl}api/Tasaciones/get_ps_stats/`);
  }

  getTasacionesLookup(searchTerm: string): Observable<LookupData> {
    return this.http.get<LookupData>(this.myAppUrl + 'api/Tasaciones/Lookup?k=' + searchTerm);
  }

  getTasacionesLookupId(id: number): Observable<LookupData> {
    return this.http.get<LookupData>(this.myAppUrl + 'api/Tasaciones/Lookup/' + id.toString());
  }


}
